export const GTM_ID_REGEX = /^GTM-[A-Z0-9]+$/;

export const FACEBOOK_EVENTS_ID_REGEX = /^\d+$/;

export const DOMAIN_REGEX = /^[a-z0-9.:-]+$/i;

export const PRODUCTION_GTM_ID = 'GTM-PWM4TFK';

export const PRODUCTION_FACEBOOK_EVENTS_ID = '424055375942118';
